'use client'

import { Button } from '@repo/ui/components/button'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FunctionComponent } from 'react'
import { useRefinementUrl } from '../../../hooks/useRefinementUrl.hook'
import { useSheet } from '../../../providers/SheetProvider'
import { PageDto } from '../../../types/page.types'
import CollectionQuantity from './CollectionQuantity'

interface Props {
  pageDto: PageDto
  productCount: number
}

const CollectionFiltersSheetFooter: FunctionComponent<Props> = ({ pageDto, productCount }) => {
  const { closeSheet } = useSheet()
  const pathname = usePathname()
  const { count } = useRefinementUrl()

  return (
    <div className='flex w-full items-center justify-between'>
      <CollectionQuantity pageDto={pageDto} className='uppercase' quantity={productCount} />
      <div>
        {count > 0 && (
          <Button variant='secondaryStatic' asChild={true}>
            <Link href={pathname} onClick={closeSheet}>
              {pageDto.dictionary?.filter?.resetfilters || 'Reset Filters'}
            </Link>
          </Button>
        )}
        <Button variant='defaultStatic' onClick={closeSheet}>
          {pageDto.dictionary?.filter?.viewitems || 'View Items'}
        </Button>
      </div>
    </div>
  )
}

export default CollectionFiltersSheetFooter
